import { PAGES } from "@/common/consts";

export default {
	namespaced: true,
	state: {
		currentRouteName: "",
	},
	actions: {},
	mutations: {
		SET_CURRENT_ROUTE_NAME: (state, value) => {
			state.currentRouteName = value;
		},
	},
	getters: {
		isHomePage: (state) => {
			return state.currentRouteName === PAGES.HOME;
		},
		isUnscramblerLandingPage: (state) => {
			return state.currentRouteName === PAGES.UNSCRAMBLE;
		},
		isUnscramblerResultsPage: (state) => {
			return state.currentRouteName === PAGES.UNSCRAMBLER_RESULTS;
		},
		isUnscramblerResultsRememberPage: (state) => {
			return (
				state.currentRouteName === PAGES.UNSCRAMBLER_RESULTS_REMEMBER
			);
		},
		isScrabblePage: (state) => {
			return state.currentRouteName === PAGES.SCRABBLE_DICT;
		},
		isScrabbleResultsPage: (state) => {
			return state.currentRouteName === PAGES.SCRABBLE_DICT_RESULTS;
		},
		isScrabbleExactMatchResultsPage: (state) => {
			return state.currentRouteName === PAGES.SCRABBLE_EXACTMATCH_RESULTS;
		},
		isAnyScrabblePage: (state) => {
			return [
				PAGES.SCRABBLE_DICT,
				PAGES.SCRABBLE_CHECKER,
				PAGES.SCRABBLE_DICT_RESULTS,
			].includes(state.currentRouteName);
		},
		is4Pics1WordResultsPage: (state) => {
			return state.currentRouteName === PAGES.FOURPICS_RESULTS;
		},
		is4Pics1WordPage: (state) => {
			return state.currentRouteName === PAGES.FOURPICS;
		},
		isAnagramPage: (state) => {
			return state.currentRouteName === PAGES.ANAGRAM;
		},
		isAnagramResultsPage: (state) => {
			return state.currentRouteName === PAGES.ANAGRAM_RESULTS;
		},
		isWordlePage: (state) => {
			return state.currentRouteName === PAGES.WORDLE;
		},
		isQuordlePage: (state) => {
			return state.currentRouteName === PAGES.QUORDLE;
		},
		isQuordleResultsPage: (state) => {
			return state.currentRouteName === PAGES.QUORDLE_RESULTS;
		},
		isWordleResultsPage: (state) => {
			return state.currentRouteName === PAGES.WORDLE_RESULTS;
		},
		isWordsEndingInINGResultsPage: (state) => {
			return state.currentRouteName === PAGES.WORDS_ENDING_ING;
		},
		isQNoUResultsPage: (state) => {
			return state.currentRouteName === PAGES.WORDS_WITH_Q_NO_U;
		},
		isVowelsResultsPage: (state) => {
			return state.currentRouteName === PAGES.WORDS_VOWELS;
		},
		isConsonantsResultsPage: (state) => {
			return state.currentRouteName === PAGES.WORDS_CONSONANTS;
		},
		isWordsThatEndsInResultsPage: (state) => {
			return state.currentRouteName === PAGES.WORDS_ENDING_RESULTS;
		},
		isWordsThatStartsWithResultsPage: (state) => {
			return state.currentRouteName === PAGES.WORDS_STARTING_RESULTS;
		},
		isWordsWithTheLetterResultsPage: (state) => {
			return state.currentRouteName === PAGES.WORDS_HAVING_RESULTS;
		},
		isWordsByLengthResultsPage: (state) => {
			return state.currentRouteName === PAGES.WORDS_BY_LENGTH_RESULTS;
		},
		isJumbleSolverPage: (state) => {
			return state.currentRouteName === PAGES.JUMBLE_SOLVER;
		},
		isWordScramblePage: (state) => {
			return state.currentRouteName === PAGES.WORD_SCRAMBLE;
		},
		isLandingPage: (state) => {
			return [
				PAGES.HOME,
				PAGES.WWF,
				PAGES.WORDS_CONSONANTS,
				PAGES.WORDS_VOWELS,
				PAGES.WORDS_ENDING_ING,
				PAGES.WORDS_WITH_Q_NO_U,
				PAGES.UNSCRAMBLE,
				PAGES.WORD_DESCRAMBLER,
				PAGES.WORD_UNSCRAMBLER,
				PAGES.SCRABBLE_DICT,
				PAGES.WORDFEUD,
				PAGES.WORD_CONNECT,
				PAGES.WORDBRAIN_ANSWERS,
				PAGES.WORD_STORY,
				PAGES.WORD_CHUMS_CHEAT,
				PAGES.ANAGRAM,
				PAGES.FOURPICS,
				PAGES.JUMBLE_SOLVER,
				PAGES.WORDCOOKIES,
				PAGES.TEXT_TWIST,
				PAGES.CODY_CROSS,
				PAGES.WORD_SWIPE_CHEATS,
				PAGES.WORDLE,
				PAGES.QUORDLE,
			].includes(state.currentRouteName);
		},
		isResultsPage: (state) => {
			return [
				PAGES.UNSCRAMBLER_RESULTS,
				PAGES.SCRABBLE_DICT_RESULTS,
				PAGES.FOURPICS_RESULTS,
				PAGES.SCRABBLE_EXACTMATCH_RESULTS,
				PAGES.UNSCRAMBLER_RESULTS_REMEMBER,
				PAGES.WORDS_BY_LENGTH_RESULTS,
				PAGES.WORDS_CONSONANTS,
				PAGES.WORDS_ENDING_ING,
				PAGES.WORDS_ENDING_RESULTS,
				PAGES.WORDS_HAVING_RESULTS,
				PAGES.WORDS_STARTING_RESULTS,
				PAGES.WORDS_VOWELS,
				PAGES.WORDS_WITH_Q_NO_U,
				PAGES.WORDLE_RESULTS,
			].includes(state.currentRouteName);
		},
		isPersistentSearch(state, getters) {
			return (
				!getters.isAnagramResultsPage &&
				!getters.isWordleResultsPage &&
				getters.isResultsPage
			);
		},
		isSavedWordsPage(state) {
			return state.currentRouteName == PAGES.SAVED_WORDS;
		},
		isStaticLandingPage(state) {
			return [
				PAGES.WWF,
				PAGES.WORD_CONNECT,
				PAGES.WORDCOOKIES,
				PAGES.FOURPICS,
				PAGES.WORD_CHUMS_CHEAT,
				PAGES.WORD_SCRAMBLE,
				PAGES.TEXT_TWIST,
				PAGES.WORDFEUD,
				PAGES.CODY_CROSS,
				PAGES.WORD_SWIPE_CHEATS,
				PAGES.WORDBRAIN_ANSWERS,
				PAGES.WORD_STORY,
			].includes(state.currentRouteName);
		},
		isStaticRender(state, getters) {
			return (
				typeof window.__PRERENDER_INJECTED !== "undefined" &&
				getters.isStaticLandingPage
			);
		},
		isSemanticTablePage(state) {
			return [
				PAGES.UNSCRAMBLER_RESULTS,
				PAGES.WORDS_HAVING_RESULTS,
				PAGES.WORDS_STARTING_RESULTS,
				PAGES.WORDS_ENDING_RESULTS,
				PAGES.WORDS_BY_LENGTH_RESULTS,
				PAGES.WORDS_VOWELS,
				PAGES.WORDS_CONSONANTS,
				PAGES.WORDS_ENDING_ING,
				PAGES.WORDS_WITH_Q_NO_U,
			].includes(state.currentRouteName);
		},
		isCommerceWidgetPage(state, getters, rootState) {
			return (
				[
					PAGES.UNSCRAMBLER_RESULTS,
					PAGES.WORDS_HAVING_RESULTS,
					PAGES.WORDS_BY_LENGTH_RESULTS,
					PAGES.WORDS_STARTING_RESULTS,
					PAGES.WORDS_ENDING_RESULTS,
					PAGES.SCRABBLE_DICT_RESULTS,
					PAGES.ANAGRAM_RESULTS,
					PAGES.WORDLE_RESULTS,
				].includes(state.currentRouteName) &&
				rootState.login.location === "US"
			);
		},
	},
};
